import { render } from "./AnagraficaClientiCaldi.vue?vue&type=template&id=49372796&scoped=true"
import script from "./AnagraficaClientiCaldi.vue?vue&type=script&lang=js"
export * from "./AnagraficaClientiCaldi.vue?vue&type=script&lang=js"

import "./AnagraficaClientiCaldi.vue?vue&type=style&index=0&id=49372796&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49372796"]])

export default __exports__